<template>
    <div class="abnormal">
        <div class="abnormal-box">
            <div class="abnormal-box-btns">
                异常数据总计
            </div>
            <div class="abnormal-box-content">
                <div class="abnormal-item" title="点击查看用户列表"> 
                    <div class="abnormal-item-lf">
                        <img src="~@/assets/images/icons/icon_total.png" alt="">
                    </div>    
                    <div class="abnormal-item-rt">
                        <el-button type="text" @click="allAbnormal" :disabled="abnormalObj.total < 1">{{ abnormalObj.total }}</el-button>
                        <span>异常人次总数</span> 
                    </div>                      
                </div>
                <div class="abnormal-item" title="点击查看用户列表"> 
                    <div class="abnormal-item-lf">
                        <img src="~@/assets/images/icons/icon_bloodpressure.png" alt="">
                    </div>
                    <div class="abnormal-item-rt">                   
                        <el-button type="text" @click="bloodPressure" :disabled="abnormalObj.blood_pressure_total < 1">{{ abnormalObj.blood_pressure_total }}</el-button>
                        <span>血压异常人次</span>
                    </div>
                </div>
                <div class="abnormal-item" title="点击查看用户列表">    
                    <div class="abnormal-item-lf">
                        <img src="~@/assets/images/icons/icon_bloodsugar.png" alt="">
                    </div>
                    <div class="abnormal-item-rt">                
                        <el-button type="text" @click="bloodSugar" :disabled="abnormalObj.blood_sugar_total < 1">{{ abnormalObj.blood_sugar_total }}</el-button>
                        <span>血糖异常人次</span>
                    </div>
                </div>                
            </div>
            <div class="line-chart">
                <div class="polyline">
                    <div class="polyline-hd">
                        <div>
                            <span class="polyline-title">每日异常数据趋势图</span>
                        </div>
                        <div>
                        <el-button :type="currentDays === 7 ? 'primary' : ''" @click="currentDays = 7" >最近7天</el-button>
                        <el-button :type="currentDays === 30 ? 'primary' : ''" @click="currentDays = 30" >最近30天</el-button>
                        <el-button :type="currentDays === 60 ? 'primary' : ''" @click="currentDays = 60" >最近60天</el-button>
                        </div>
                    </div>
                    <!-- 折线图 -->
                    <div id="polyline" style="height:300px"></div>
                </div>
            </div>
        </div>
        
        <el-dialog title="用户列表" :visible.sync="listDialog" width="80%">
            <el-table :data="userData" stripe style="width: 100%; font-size:14px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="username" align="center" label="用户姓名"></el-table-column>
                <el-table-column prop="age" align="center" label="年龄"></el-table-column>
                <el-table-column prop="gender" align="center" label="性别"></el-table-column>
                <el-table-column prop="type" align="center" label="测量类型"></el-table-column>
                <el-table-column prop="result" align="center" label="分析结果"></el-table-column>
                <el-table-column prop="check_time" align="center" label="测量时间"></el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @current-change="handleCurrentChange" :page-size="size"
                    layout="total, prev, pager, next" :total="total" :size="size" :current-page="page">                
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import AbnormalAPI from '@/model/api/abnormal'
import Echarts from 'echarts'
export default {
    name: 'abnormalwarning',
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                    }
                }],
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },                      // 日期选择器设置-快捷选择、最大选择当日
            page: 1,                // 当前页
            size: 10,               // 当前每页条数
            total: 0,               // 总条数
            listDialog: false,      // 列表弹窗
            radio: 1,
            userData:[],
            dateGroup:[],
            abnormalObj:{total:0,blood_pressure_total:0,blood_sugar_total:0},
            currentDays: 7,
            type: 0,
        }
    },
    watch:{
        currentDays() {
            this.getLineData()
        }
    },
    created() {
        this.getAbnormalOfToday()
        this.getLineData()
    },
    methods: {
        // 获取今日异常
        getAbnormalOfToday() {            
            AbnormalAPI.getErrNum().then(res => { 
                this.abnormalObj = res.data.data
            })
        },
        // 获取用户列表
        getUserList() {
            let params = {
                type:this.type,
                p:this.page,
                size: this.size
            }
            AbnormalAPI.getErrUser(params).then(res => { 
                this.userData = res.data.data.list       
                this.total = res.data.data.total
                return Promise.all([this.userData,this.total])
            })
        },
        // 获取折线图数据
        getLineData() {
            AbnormalAPI.getErrLine({num:this.currentDays}).then(res => {
               this.drawPolyline(res.data.data)
            })
        },
        // 绘制折线图
        drawPolyline(res) {
            
            const mChart = Echarts.init(document.getElementById('polyline'))
            mChart.setOption({
                tooltip : {
                    trigger: 'axis'
                },
                color:["#00c6ae","#489af9","#b076f2"],  // legend图例颜色
                legend: {
                    data:[  {name: '异常人次总数', textStyle:{color:"#00c6ae"}}, 
                            {name: '血压异常人次', textStyle:{color:"#489af9"}}, 
                            {name: '血糖异常人次', textStyle:{color:"#b076f2"}}
                        ]
                },
                grid:{
                    top: '50px',
                    bottom: '0',
                    left: '20px',
                    right: '50px',
                    containLabel: true
                },
                toolbox: {
                    show : false,
                    feature : {
                        mark : {show: true},
                        dataView : {show: true, readOnly: false},
                        magicType : {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                        restore : {show: true},
                        saveAsImage : {show: true}
                    }
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : res.line_all.date,// 横轴
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        scale : true,
                        // max : 2000,
                        // min : 1,
                        minInterval: 1,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    }
                ],
                series : [
                    {
                        name:'异常人次总数',
                        type:'line',
                        smooth: true,   // 折线平滑
                        symbol: 'circle',
                        symbolSize: 3,
                        sampling: 'average',
                        itemStyle : {    
                            normal : {    
                                lineStyle:{    
                                    color:'#00c6ae'    
                                }    
                            }    
                        },
                        // 折线区域渐变色
                        areaStyle: {normal: {
                            color: new Echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: '#00c6ae'},
                                        {offset: 1, color: '#fff'}
                                    ]
                            )
                        }},
                        data:res.line_all.num  // line 2
                    },
                    
                    {
                        name:'血压异常人次',
                        type:'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 3,
                        sampling: 'average',
                        itemStyle : {    
                            normal : {    
                                lineStyle:{    
                                    color:'#489af9'    
                                }    
                            }    
                        },  
                        areaStyle: {normal: {
                            color: new Echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: '#489af9'},
                                        {offset: 1, color: '#fff'}
                                    ]
                            )
                        }},
                        data:res.line_pressure.num  // line 2
                    },
                   
                    {
                        name:'血糖异常人次',
                        type:'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        sampling: 'average',
                        itemStyle : {    
                            normal : {    
                                lineStyle:{    
                                    color:'#b076f2'    
                                }    
                            }    
                        }, 
                        areaStyle: {normal: {
                            color: new Echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: '#b076f2'},
                                        {offset: 1, color: '#fff'}
                                    ]
                            )
                        }},
                        data:res.line_sugar.num // line 3
                    }
                ]
            })
        },
        
        // 异常人次总数
        allAbnormal() {
            this.page = 1
            this.size = 10
            this.type = 0
            
            this.listDialog = true  
            this.getUserList()          
        },
        // 血压异常
        bloodPressure() {
            this.page = 1
            this.size = 10
            this.type = 1
            
            this.listDialog = true
            this.getUserList()
        },
        // 血糖异常
        bloodSugar() {
            this.page = 1
            this.size = 10
            this.type = 2            
            this.listDialog = true
            this.getUserList()
        },
        
        // 分页改变
        handleCurrentChange(val) {
            this.page = val
            this.getUserList()
        },
        
    }
}
</script>
<style lang="scss" scoped>
    .abnormal{
        background: #f1f2f7;
        padding: 10px;
        .abnormal-box{
            width: 100%;
            height: 100%;
            line-height: 50px;
            background: #fff;
            margin-bottom: 10px;
            border-radius: 5px;
            .abnormal-box-btns{
                width: 100%;
                padding: 20px;
                font-size: 15px;
                font-weight: bold;
            }
            
            .abnormal-box-content{
                width: 100%;
                display: flex;
                justify-content: center;
                .abnormal-item{
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    border-radius: 5px;
                    width: 278px;
                    height: 120px;
                    margin: 0 50px;
                    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);                
                    font-size: 15px;
                    &:nth-child(1) {
                        background: -webkit-linear-gradient(#00E5D7 20%,#00C6AE 80%);
                        background: linear-gradient(#00E5D7 20%,#00C6AE 80%);
                    }
                    &:nth-child(2) {
                        background: -webkit-linear-gradient( #7ECAFD 20%,#489AF9 80%);
                        background: linear-gradient(#7ECAFD 20%,#489AF9 80%);
                    }
                    &:nth-child(3) {
                        background: -webkit-linear-gradient( #A681FF 20%,#B076F2 80%);
                        background: linear-gradient(#A681FF 20%,#B076F2 80%);
                    }
                    .abnormal-item-lf{
                        width: 58px;
                        height: 58px;
                        background: #F1F8FE;
                        border-radius: 50%;
                        padding:12px;
                        text-align: center;
                        img{     
                            width: 24px;
                            height: 28px;                       
                            background-size: contain;
                            background-repeat: no-repeat;
                        }
                    }
                    .abnormal-item-rt{
                        
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        
                        .el-button{
                            font-weight: bold;
                            font-size: 36px;
                            // text-decoration: underline;
                            color: #fff;
                            // cursor: pointer;
                        }
                        
                    }
                }
                
            }
            .line-chart{
                margin-top: 50px;
                .numerical {
                    padding: 0;
                    height: 142px;
                }
                .graph {
                    height: 240px;
                }
                .polyline {
                    height: 250px;
                }
                .polyline {
                    padding: 20px;
                    &-hd {
                        height: 30px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                    &-title {
                        font-size: 15px;
                        font-weight: bold;
                        font-weight: 600;
                        line-height: 30px;
                    }
                    &-subtitle {
                        font-size: 12px;
                        color: $small-text-color;
                    }
                    #polyline {
                        height: 100%;
                    }
                }
            }
        }
        .pagination-box{
            text-align: right;
        }
    }
</style>
